export interface Terminal {
  id: number;
  primaryTermicalId: string;
  countryCode: string;
  name: string;
  sapId: string;
}

export function GetTerminalDisplayName(terminal: Terminal): string {
  return `${terminal.name} (${terminal.sapId})`;
}